import axios from 'axios';
import { Navigate } from 'react-router-dom';

import { getCSRFToken, setRedirectionPath } from 'utils';
import { XIQ_ONLINE_URL } from 'constants/index';
import { setErrorCodeAction, setErrorPageAction } from 'modules/Error/actions';

const instance = axios.create({
  timeout: 1000 * 120, //wait for 120 seconds
  withCredentials: true,
});

instance.interceptors.request.use(async (req) => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  req.headers['X-CSRFToken'] = getCSRFToken();
  if (req.method === 'get') {
    req.url = req.url.includes('?') ? req.url + '&user_tz=' + tz : req.url + '?user_tz=' + tz;
  } else if (req.method === 'post' || req.method === 'put') {
    if (!req.data) {
      let data = new FormData();
      data.append('user_tz', tz);
      req.data = data;
    } else if (req.data instanceof FormData) {
      // data is in form data
      req.data.append('user_tz', tz);
    } else {
      req.data.user_tz = tz;
    }
  }
  return req;
});

instance.interceptors.response.use((response) => {
  try {
    if (
      response.status === 200 &&
      (response?.data?.message?.toLowerCase() === 'permission denied' || response.data?.error_code === 403)
    ) {
      // alert("You do not have Permissions to access this resource");
      setErrorPageAction(window.location.pathname);
      setErrorCodeAction(403);
      return;
    }
    return response;
  } catch (e) {
    return response;
  }
});

instance.interceptors.response.use(null, (error) => {
  if (error?.response?.status === 403) {
    localStorage.removeItem('csrfToken');
    let hostName = window.location.hostname;
    if (hostName !== 'localhost') {
      setRedirectionPath();
      // setCookie("isLogout", "1");
      window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
    } else {
      setRedirectionPath();
      return <Navigate to={'/'} />;
    }
  }
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if (error && error.response && [400, 401, 404, 408, 500, 503].indexOf(error.response.status) > -1) {
    setErrorPageAction(window.location.pathname);
    setErrorCodeAction(error.response.status);
  }
  // else if (error.response === undefined) {
  //   setErrorPageAction(window.location.pathname);
  //   setErrorCodeAction(503);
  // }
  if (!expectedError) {
    // logger.log(error);
    // toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

const http = {
  get: instance.get,
  post: instance.post,
  put: instance.put,
  delete: instance.delete,
};

export default http;
